import axios from "@/libs/api.request";

export const getLost = data => {
  return axios.request({
    url: "/shipments/lost",
    method: "get",
    data
  });
};

// 新增丢件
export const add = data => {
  return axios.request({
    url: "/shipments/lost",
    method: "post",
    data
  });
};
